export default __webpack_public_path__ + "static/transaction-page-requested-d05865781dbbe5d678b732e6ef8e1f38.png";